import CategoryPicker from 'src/CategoryPicker';
import InputGroup from 'src/InputGroup';
import PayeeInput from 'src/inputs/PayeeInput';
import {TextInput} from 'src/inputs/TextInput';
import type {Option} from '@danwang/option';

export type FormState = {
  payee: string;
  description: string;
  category: Option<string>;
};

export const TransactionForm = ({
  formId,
  form,
  onChange,
  onSubmit,
}: {
  formId: string;
  form: FormState;
  onChange: <K extends keyof FormState>(key: K) => (value: FormState[K]) => void;
  onSubmit: (e: React.FormEvent) => void;
}) => (
   
  <form id={formId} onSubmit={onSubmit} className="flex flex-col gap-4">
    <InputGroup label="Payee">
      <PayeeInput value={form.payee} onChange={onChange('payee')} />
    </InputGroup>
    <InputGroup label="Description">
      <TextInput value={form.description} onChange={onChange('description')} />
    </InputGroup>
    <InputGroup label="Category">
      <CategoryPicker
        selectedCategory={form.category}
        onSelectCategory={onChange('category')}
      />
    </InputGroup>
  </form>
);
